import { GAME_ID, REDUX_ACTIONS } from 'a/zoomBoom/data/constants';

const initialState = [];

const wordListReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.LOAD_WORD_LIST:
      return payload;

    default:
      return state;
  }
};

export default wordListReducer;
